import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { initialState } from './constants';
import { ICustomState } from './types';

const customDataSlice = createSlice({
  name: 'custom',
  reducers: {
    setCustomData: (state, action: PayloadAction<ICustomState>) => {
      return action.payload;
    },
  },
  initialState,
});

export const customDataReducer = customDataSlice.reducer;
export const { setCustomData } = customDataSlice.actions;
